

import React, { useState, useEffect } from 'react';
import Parse from 'parse';

import ShareModal from '../helpers/shareModal.js';
import EnquireModal from '../helpers/enquireModal.js';

import '../styles/phcolours.css';

import useUIPresentationMode from '../helpers/useUIPresentationMode.js';


/*-------------------------------------------------------------------------------*/


const topButtonStyle = {
  padding: '9px 16px',
  fontSize: '16px',
  fontWeight: '600',
  border: 'none',
  borderRadius: '999px',
  cursor: 'pointer',
  background: 'var(--phblueaccentwashedwithtransparency)',
  color: 'var(--phblue)',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  boxShadow: 'var(--ph-box-shadow-nothover)',
  transition: 'all 0.2s ease-in-out',
};

const topButtonStyleShareGreen = {
  padding: '9px 16px',
  fontSize: '16px',
  fontWeight: '600',
  border: 'none',
  borderRadius: '999px',
  cursor: 'pointer',
  background: 'var(--phgreenwashedwithtransparency)',
  color: 'var(--phgreenfont)',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  boxShadow: 'var(--ph-box-shadow-nothover)',
  transition: 'all 0.2s ease-in-out',
};


/*-------------------------------------------------------------------------------*/


const UITopButtons = ({ onDropPlanClick, showDropPlan, onSearchClick, presentationModeiFrame }) => {


  const [, setIsFullscreen] = useState(false);  // This tells React (and ESLint): “I’m intentionally not using the first part of the tuple.”

  const [isShareOpen, setIsShareOpen] = useState(false);

  const user = Parse.User.current();
  const guestIdentifiers = ['guest@planhub.app'];
  const userIsGuest = user && guestIdentifiers.includes(user.get('username'));
  const userIsPublic = user && user.get('isMemberOfPublic') === 1;
  const shouldShowEnquireButton = userIsGuest || userIsPublic;
  //const shouldShowEnquireButton = 1;


  const [isEnquireOpen, setIsEnquireOpen] = useState(false);

  const { presentationModeSize } = useUIPresentationMode();
  const isVeryNarrowScreen = presentationModeSize >= 4;


  /*-----------------------------------------------------------------------------*/


  useEffect(() => {

    const handleFullscreenChange = () => {
      setIsFullscreen(
        !!(document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement)
      );
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, [setIsFullscreen]);


  const handleFullscreenToggle = () => {

    if (presentationModeiFrame === 1) {

      const url = new URL(window.location.href);
      //console.log('url', url);
      window.open(`https://go.planhub.app${url.pathname}${url.search}`, '_blank');
    }
    else {

      const elem = document.documentElement;

      if (!document.fullscreenElement) {
        elem.requestFullscreen?.().catch(err => console.error(`Error: ${err.message}`));
      }
      else {
        document.exitFullscreen?.();
      }
    }
  };


  // Scale this mofo depending on screen size.
  const [scaleFactor, setScaleFactor] = useState(0.9);

  useEffect(() => {
    if (presentationModeSize === 1 || presentationModeSize === 2) {  // Big!
      setScaleFactor(1);
    }
    if (presentationModeSize === 3) {  // Not as big.
      setScaleFactor(0.9);
    }
    if (presentationModeSize === 4 || presentationModeSize === 5) {  // Little!
      setScaleFactor(0.9);
    }
  }, [presentationModeSize]);


  /*-----------------------------------------------------------------------------*/


  return (
    <>
      <div className="ui-top-buttons" style={{
        position: 'absolute',
        width: '90%',
        maxWidth: '720px',
        top: '15px',
        left: '50%',
        transform: `translate(-50%) scale(${scaleFactor})`,
        display: 'flex',
        alignItems: 'center',
        gap: isVeryNarrowScreen ? '13px' : '20px',
        zIndex: 1000,
        backgroundColor: 'transparent',
        whiteSpace: 'nowrap',
        flexWrap: 'wrap', // 🛠️ ALLOW wrapping on very narrow screens
        justifyContent: 'center',
        padding: '7px 35px',
      }}>
        {showDropPlan && (
          <button
            onClick={onDropPlanClick}
            style={topButtonStyle}
            onMouseEnter={(e) => e.target.style.boxShadow = 'var(--ph-box-shadow-hover)'}
            onMouseLeave={(e) => e.target.style.boxShadow = 'var(--ph-box-shadow-nothover)'}
          >
            Drop Plan
          </button>
        )}

        <button
          onClick={onSearchClick}
          style={topButtonStyle}
          onMouseEnter={(e) => e.target.style.boxShadow = 'var(--ph-box-shadow-hover)'}
          onMouseLeave={(e) => e.target.style.boxShadow = 'var(--ph-box-shadow-nothover)'}
        >
          Search
        </button>

        <button
          onClick={handleFullscreenToggle}
          style={topButtonStyle}
          onMouseEnter={(e) =>
            (e.target.style.boxShadow = 'var(--ph-box-shadow-hover)')}
          onMouseLeave={(e) =>
            (e.target.style.boxShadow = 'var(--ph-box-shadow-nothover)')}
        >
          {presentationModeiFrame === 1 ? 'Expand' : 'Fullscreen'}

        </button>

        <button
          onClick={() => setIsShareOpen(true)}
          style={topButtonStyleShareGreen}
          onMouseEnter={(e) => e.target.style.boxShadow = 'var(--ph-box-shadow-hover)'}
          onMouseLeave={(e) => e.target.style.boxShadow = 'var(--ph-box-shadow-nothover)'}
        >
          Share
        </button>

        {shouldShowEnquireButton && (
          <button
            onClick={() => setIsEnquireOpen(true)}
            style={topButtonStyleShareGreen}
            onMouseEnter={(e) => e.target.style.boxShadow = 'var(--ph-box-shadow-hover)'}
            onMouseLeave={(e) => e.target.style.boxShadow = 'var(--ph-box-shadow-nothover)'}
          >
            Get Price
          </button>
        )}

      </div>

      <ShareModal isOpen={isShareOpen} onClose={() => setIsShareOpen(false)} />
      <EnquireModal isOpen={isEnquireOpen} onClose={() => setIsEnquireOpen(false)} />
    </>
  );
};


export default UITopButtons;


